const NAME_PRE = 'hc';
export {
  NAME_PRE
};